var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_notification",
    "data-name": "vuesax/bold/notification",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.029,12.49l-1-1.66a3.715,3.715,0,0,1-.4-1.48V6.82a5.909,5.909,0,0,0-3.37-5.33A2.926,2.926,0,0,0,7.679,0a2.961,2.961,0,0,0-2.59,1.52,5.928,5.928,0,0,0-3.3,5.3V9.35a3.626,3.626,0,0,1-.4,1.47L.379,12.49a2.337,2.337,0,0,0,1.31,3.53,18.7,18.7,0,0,0,6.02.98,18.969,18.969,0,0,0,6.02-.97,2.411,2.411,0,0,0,1.3-3.54Z",
    transform: "translate(4.311 2)",
    fill: "#a5a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.65.01A3.014,3.014,0,0,1,2.82,2,2.965,2.965,0,0,1,.7,1.11,2.761,2.761,0,0,1,0,0C.13.02.26.03.4.05c.23.03.47.06.71.08.57.05,1.15.08,1.73.08S3.98.18,4.54.13c.21-.02.42-.03.62-.06Z",
    transform: "translate(9.18 20)",
    fill: "#a5a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(24 24) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti);
export default __webpack_public_path__ + "static/media/noti.62bd88f1fe769eb09745d38ad5f17bab.svg";
export { ForwardRef as ReactComponent };